let hlsInstances = new WeakMap();
let accordionInstances = new Map(); // Add this line to store accordion instances
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('[data-accordion-content]');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }
  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    // Close other accordions before opening this one
    if (!this.isClosing && !this.el.open) {
      // Get all accordion instances and close siblings
      accordionInstances.forEach((instance, element) => {
        if (element !== this.el && element.open) {
          instance.shrink();
        }
      });
    }
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}
document.addEventListener("DOMContentLoaded", function () {
  let selectors = {
    productExercises: '.product-exercises',
    exerciseButton: '.exercise__button',
    currentExerciseVideo: '.current-exercise__video',
    currentExerciseName: '.current-exercise__name',
    currentExerciseCountWrapper: '.current-exercise__count',
    playButton: '.current-exercise__video__play-button',
    muscleGroupAccordion: '.muscle-group__accordion',
    exercisePoster: '.exercise__poster',
    classes: {
      activeButton: 'exercise__button--active',
      videoPlaying: 'current-exercise__video--playing'
    }
  }
  const pauseVideo = (video, parent) => {
    video.pause();
    parent.classList.remove(selectors.classes.videoPlaying);
  }
  const playVideo = (video, parent) => {
    video.play();
    parent.classList.add(selectors.classes.videoPlaying);
  }
  // Replace the accordion initialization code with this
  document.querySelectorAll('.product-exercises details').forEach((el) => {
    accordionInstances.set(el, new Accordion(el));
  });
  let buttons = document.querySelectorAll(`${selectors.productExercises} ${selectors.exerciseButton}`);
  buttons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      let button = e.target.closest(selectors.exerciseButton);
      let accordion = button.closest(selectors.muscleGroupAccordion);
      let videoWrapper = accordion.querySelector(`${selectors.currentExerciseVideo}`);
      let video = videoWrapper.querySelector('video');
      let currentExerciseName = accordion.querySelector(selectors.currentExerciseName);
      let currentExerciseCountWrapper = accordion.querySelector(selectors.currentExerciseCountWrapper);
      let currentExerciseCount = accordion.querySelector('.current-exercise__count__current');
      accordion
        .querySelectorAll(selectors.exerciseButton)
        .forEach((b) => b.classList.remove(selectors.classes.activeButton));
      videoWrapper.classList.remove('show');
      currentExerciseName.classList.remove('show');
      currentExerciseCountWrapper.classList.remove('show');
      button.classList.toggle(selectors.classes.activeButton);
      setTimeout(() => {
        let posterSrc = button.dataset.exercisePoster;
        let posterEl = accordion.querySelector(selectors.exercisePoster);
        // pause video after hiding
        if(accordion.classList.contains(selectors.classes.videoPlaying)) pauseVideo(video, accordion);
        // update content
        currentExerciseName.innerHTML = button.dataset.exerciseName;
        // Update alt text and aria-label dynamically
        const exerciseName = button.dataset.exerciseName;
        const posterImg = accordion.querySelector('.exercise__poster');
        posterImg.alt = exerciseName;
        const playBtn = accordion.querySelector('.current-exercise__video__play-button');
        playBtn.setAttribute('aria-label', `Play ${exerciseName} exercise video`);
        currentExerciseCount.textContent = button.dataset.exerciseIndex;
        const videoSrc = button.dataset.exerciseVideo;
        const isHLS = videoSrc.includes('.m3u8');
        // Destroy previous HLS instance if exists
        if (hlsInstances.has(video)) {
          hlsInstances.get(video).destroy();
          hlsInstances.delete(video);
        }
        if (isHLS && Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(videoSrc);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => video.play());
          hlsInstances.set(video, hls);
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          // Native Safari HLS support
          video.src = videoSrc;
          video.addEventListener('loadedmetadata', () => video.play());
        } else {
          // Regular MP4 fallback
          video.querySelector('source').src = videoSrc;
          video.load();
        }
        video.poster = posterSrc;
        posterEl.src = posterSrc;
        posterEl.setAttribute('srcset', posterSrc);
      }, 200);
      setTimeout(() => {
        videoWrapper.classList.add('show');
        currentExerciseName.classList.add('show');
        currentExerciseCountWrapper.classList.add('show');
      }, 500);
    });
  });
  let playButtons = document.querySelectorAll(selectors.playButton);
  playButtons.forEach((playBtn) => {
    playBtn.addEventListener('click', function (e) {
      e.preventDefault();
      let video = e.target.closest(selectors.currentExerciseVideo).querySelector('video');
      let accordion = video.closest(selectors.muscleGroupAccordion);
      if(accordion.classList.contains(selectors.classes.videoPlaying)) {
        pauseVideo(video, accordion);
      }else{
        playVideo(video, accordion);
      }
    });
  });
  // Open the first accordion by default
  const firstAccordion = document.querySelector(`${selectors.productExercises} ${selectors.muscleGroupAccordion}`);
  if (firstAccordion) {
    // Set open attribute and trigger expansion
    firstAccordion.open = true;
    // Use the existing accordion instance instead of creating a new one
    if (accordionInstances.has(firstAccordion)) {
      accordionInstances.get(firstAccordion).onAnimationFinish(true);
      firstAccordion.style.height = 'auto';
    }
  }
});